import { useTranslation } from 'react-i18next';
import { Trophy } from 'lucide-react';
import { formatCents } from '@/lib/format';
import { normalizeRankingConfig, rankingPrizePool } from '@/lib/campaigns/rankingCompetition';

export function RankingCampaignSummary({ config, currency = 'BRL' }: { config: unknown; currency?: string }) {
  const { t, i18n } = useTranslation();
  const settings = normalizeRankingConfig(config);
  return <div className="space-y-1.5" data-testid="ranking-campaign-summary">
    <p className="flex items-center gap-1.5 text-xs font-medium text-primary"><Trophy aria-hidden="true" className="h-3.5 w-3.5" />{t('ranking.types.ranking')}</p>
    <p className="text-xl font-bold tabular-nums">{formatCents(rankingPrizePool(settings), currency)}<span className="ml-1 text-xs font-normal text-muted-foreground">{t('ranking.pool')}</span></p>
    <p className="text-xs text-muted-foreground">{t('ranking.minimumSummary', { views: settings.min_total_views.toLocaleString(i18n?.resolvedLanguage || i18n?.language) })}</p>
    <p className="text-xs font-medium">{t(`ranking.payment.${settings.payout_destination}`)}</p>
  </div>;
}
